import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);

const routes = [
  {
    path: "/MemberCenter",
    name: "MemberCenter",
    component: () =>import("../views/MemberCenter.vue"),
  },
  {
    path: "/Community",
    name: "Community",
    component: () =>import("../views/Community.vue"),
  },
];
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach(async function(to, from, next) {
    NProgress.start()
    next();
});
router.afterEach(() => {
    NProgress.done()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js